var React = require('react');

function Bandcamp (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M20,0h1.82V4.35h0A3,3,0,0,1,24.28,3c2.59,0,3.85,2.05,3.85,4.54C28.13,9.84,27,12,24.58,12a2.9,2.9,0,0,1-2.85-1.4h0v1.17H20V0ZM24,4.5c-1.53,0-2.31,1.2-2.31,3s.84,3,2.31,3c1.66,0,2.28-1.52,2.28-3S25.54,4.5,24,4.5Z","key":0}),React.createElement("path",{"d":"M34.83,6.1A1.75,1.75,0,0,0,33,4.5c-.94,0-2.26.51-2.26,3.1,0,1.42.6,2.92,2.18,2.92a2,2,0,0,0,2-1.95h1.82C36.31,10.78,35,12,32.87,12c-2.58,0-4-1.89-4-4.4S30.23,3,32.94,3c1.91,0,3.53,1,3.71,3.08Z","key":1}),React.createElement("path",{"d":"M13.62,11.74H0L6.36,0H20Z","key":2})]));
}

Bandcamp.defaultProps = {"width":"36.65","height":"12","viewBox":"0 0 36.65 12"};

module.exports = Bandcamp;

Bandcamp.default = Bandcamp;
